module.exports = __webpack_public_path__ + "img/two2.d61bee3e.png";